import api from "@/services/api";
import {clearRequestIndicators, prepareRequestIndicators, successRequestIndicators} from "@/services/helper";

export default {
    /**
     * GET ALL USERS
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    GET_USERS: async ({ commit }) => {
        prepareRequestIndicators(commit, true)
        commit('setUsers', [])
        
        try {
            const axios = api('node-api')
            const response = await axios.get('/users')
            
            if (response.data.users) {
                commit('setUsers', response.data.users || [])
                successRequestIndicators(commit, response.data.message)
            }
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
    /**
     * Search for user
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    SEARCH_FOR_USER: async ({ commit }, payload) => {
        prepareRequestIndicators(commit, true)
        commit('setSearchedUsers', [])
        
        try {
            const axios = api('node-api')
            const response = await axios.get(`/users/by/search?param=${payload.search}`)
            
            if (response.data.searchedUsers) {
                commit('setSearchedUsers', response.data.searchedUsers || [])
                successRequestIndicators(commit, response.data.message)
            }
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
    /**
     * generate for user
     * @param commit
     * @param getters
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    GENERATE_GUEST_USER: async ({ commit, getters }, payload) => {
        prepareRequestIndicators(commit, true)
        commit('setSearchedUsers', [])

        try {
            const axios = api('node-api')
            const response = await axios.post(`/users/guest/generate`, payload)

            if (response.data.guestUser) {
                if (response.data.table) {
                    const tables = (getters.tables || [])
                    tables.find((table) => {
                        if (table._id === payload._id) {
                            return response.data.table
                        }
                    })

                    commit('setTables', tables)
                    commit('setTable', response.data.table)
                    successRequestIndicators(commit, response.data.message)
                    return tables
                }
                commit('setGuestUser', response.data.guestUser || null)
                successRequestIndicators(commit, response.data.message)
            }
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
    /**
     * Delete a user
     * @param commit
     * @param getters
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    DELETE_USER: async ({ commit, getters }, payload) => {
        prepareRequestIndicators(commit, true)

        try {
            const axios = api('node-api')
            const response = await axios.delete(`/users/delete`, {data: payload})

            if (response.data.user) {
                let users = (getters.users || [])
                users = users.filter((user) => {
                    return user.email !== payload.email
                })

                commit('setUsers', users)
                successRequestIndicators(commit, response.data.message)
            }
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
}


